export const initialState: any = {
    MediaName: "",
    PricingValue: "",
    File: "",
    Comment: "",
    Height: 500,
    Width: 500
  }